// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import * as CryptoJS from 'crypto-js';

let cv = '';

function generateRandomString(length: number): string {
  let text = '';
  const codeVerifier = localStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    cv = text;
    localStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier: string): string {
  const codeChallenge = base64URL(CryptoJS.SHA256(codeVerifier));
  return codeChallenge;
}

function base64URL(string: CryptoJS.lib.WordArray): string {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}
 
export const environment = {
  production: true,
  envName: 'prod',
  hostname: 'wlp.toyota.com',
  _comment: '\'api\' key contains parameters to configure amazonaws API',
  api: {
    resourceName: 'a90qbdzt1i.execute-api.us-east-1.amazonaws.com/wlp/wlp-api-gw-resource-prd-02'
  },
  wlpUrls: {
    wlpSetup: '/wlp-srv-01-prd-02-us-east-1a-warehouse-setup',
    warehouseTrailer: '/wlp-srv-03-prd-02-us-east-1a-warehouse-trailers',
    unloadPlan: '/wlp-srv-02-prd-02-us-east-1a-unload-plan', 
  },
  debugging: false,
  logger: {
    level: 'INFO',
    client_secret: 'atqki34fVSfV489haDYa3RrelLY4Yt9VWiBBUd4Ja+o=',
    navigateToLoginRequestUrl: true,
  },
  azureConfig: {
    tenant: 'TOYOTA1.onmicrosoft.com',
    clientId:'0b964075-0da1-46e5-9b3e-f07f7dc41848',
    response_type:'code',
    version: 'v2.0',
    redirect_uri:'https://wlp.toyota.com/',
    postLogoutRedirectUri: 'https://wlp.toyota.com/',  
    extraQueryParameter:'scope=openid profile email user.read',
    response_mode:'fragment',
    state:'12345',
    nonce:'678910' 
  },
  get baseLoginUrl() {
    const codeVerifier = localStorage.getItem('code_verifier') || generateRandomString(128);
    if (!localStorage.getItem('code_verifier')) {
      localStorage.setItem('code_verifier', codeVerifier);
    }
    const codeChallenge = generateCodeChallenge(codeVerifier);
    return `https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/authorize?client_id=0b964075-0da1-46e5-9b3e-f07f7dc41848&response_type=code&redirect_uri=https://wlp.toyota.com/&response_mode=query&scope=openid&state=23343&code_challenge=${codeChallenge}&code_challenge_method=S256`;
  },
  tokenURL: 'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/token',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  grantType: 'authorization_code',
  clientId: '0b964075-0da1-46e5-9b3e-f07f7dc41848',
  redirect_uri:'https://wlp.toyota.com/',
  redirectURI: 'https://wlp.toyota.com/',
  get codeVerifier() {
    return localStorage.getItem('code_verifier') || '';
  },
  get codeChallenge() {
    const verifier = this.codeVerifier;
    return verifier ? generateCodeChallenge(verifier) : '';
  }
};
 